<div class="w-full p-8 bg-zinc-100 flex-col justify-start items-start gap-2.5 inline-flex">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex">
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
      <div class="bg-white shadow-sm-light">
        <app-info-appel [base]="'application'" [cohorte]="cohorte"></app-info-appel>

        <div class="border-b border-gray-200 dark:border-gray-700">
          <ul class="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/candidatures/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group">
                <svg class="w-6 h-6 text-gray-800 dark:text-white mr-2" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M8 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2Zm6 1h-4v2H9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2h-1V4Zm-6 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z"
                    clip-rule="evenodd" />
                </svg>

                Candidatures
              </a>
            </li>
            <!-- <li class="me-2">
              <a [routerLink]="['/dashboard/appels/deliberation/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
                aria-current="page">
                <svg class="w-6 h-6 text-gray-800 mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                  height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9h5a2 2 0 0 0 2-2Zm-1 9a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Zm2-5a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm4 4a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Z"
                    clip-rule="evenodd" />
                </svg>
                Déliberation
              </a>
            </li> -->
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/admis/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group">
                <svg class="w-6 h-6 text-blue-600 dark:text-white mr-2" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z"
                    clip-rule="evenodd" />
                </svg>

                Admis
              </a>
            </li>
            <!-- <li class="me-2">
              <a [routerLink]="['/dashboard/appels/nonadmis/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group">
                <svg class="w-6 h-6 text-gray-800 dark:text-white mr-2" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm5.757-1a1 1 0 1 0 0 2h8.486a1 1 0 1 0 0-2H7.757Z"
                    clip-rule="evenodd" />
                </svg>
                Non&nbsp;Admis
              </a>
            </li> -->
            <!-- <li class="me-2">
              <a
                [routerLink]="['/dashboard/appels/statistiques/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
              >
                <svg
                  class="w-6 h-6 text-gray-800 dark:text-white mr-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 4v15a1 1 0 0 0 1 1h15M8 16l2.5-5.5 3 3L17.273 7 20 9.667"
                  />
                </svg>
                Statistiques
              </a>
            </li> -->
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/test/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group">
                <svg class="w-6 h-6 text-gray-800 dark:text-white mr-2" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M8 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2Zm6 1h-4v2H9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2h-1V4Zm-6 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z"
                    clip-rule="evenodd" />
                </svg>
                Test&nbsp;d'admission
              </a>
            </li>
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/statconnection/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center whitespace-nowrap p-4 text-gray-600 border-b-2 hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300">
                <svg class="w-2 h-6 text-gray-600 dark:text-white mr-2 shrink-0" id="icon" viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M30,30H22V4h8Zm-6-2h4V6H24Z"></path>
                  <path d="M20,30H12V12h8Z"></path>
                  <path d="M10,30H2V18h8Z"></path>
                  <rect data-name="<Transparent Rectangle>" id="_Transparent_Rectangle_"></rect>
                </svg>

                Statistiques de connexion
              </a>
            </li>
            <!-- <li>
            <a
              class="inline-block p-4 text-gray-400 rounded-t-lg cursor-not-allowed dark:text-gray-500"
              >Disabled</a
            >
          </li> -->
          </ul>
        </div>
        <!-- </div>
</div> -->
        <div class="w-full p-1 bg-white delib-screen admis flex-col justify-start items-start gap-2.5 inline-flex">
          <div class="w-full p-8 bg-white flex-col justify-start items-start gap-2.5 inline-flex">
            <div class="self-stretch h-full flex-col justify-start items-start gap-5 flex">
              <div class="self-stretch flex-col justify-start items-center gap-2 flex">
                <div class="self-stretch flex-col justify-start items-start gap-6 flex">
                  <div class="self-stretch h-[66px] flex-col justify-start items-start gap-5 flex">
                    <div class="self-stretch title-ctnr justify-start items-start gap-4 inline-flex">
                      <div class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
                        <div class="self-stretch text-center text-gray-900 text-3xl font-semibold mt-5">
                          Liste des admis
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Graphe Repartitions -->
                <div class="w-full p-1 justify-start items-end tarte-tab-ctnr gap-2.5 inline-flex">
                  <div class="flex tarte-ctnr">
                    <div class="mt-4 la-tarte">
                      <canvas #canvasConfirmation class="chart-canvas"></canvas>
                    </div>
                  </div>

                  <div class="flex tab-ctnr max-w-full overflow-x-auto">
                    <div class="ctnr-tableau-recap">
                      <table class="tableau-recap text-gray-900">
                        <thead class="align-center">
                          <tr>
                            <th class="px-1 py-2 inter-semibold"></th>
                            <th class="px-1 py-2 inter-semibold light-blue-bg">
                              Hommes
                            </th>
                            <th class="px-1 py-2 inter-semibold light-blue-bg">
                              Femmes
                            </th>
                            <th class="px-1 py-2 inter-semibold light-blue-bg text-center">
                              Total
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th class="px-1 py-2 inter-semibold light-blue-bg text-center">
                              Admis
                            </th>
                            <td class="px-1 py-2 inter-medium light-blue-bg text-center">
                              {{ totalHomme }}
                            </td>
                            <td class="px-1 py-2 inter-medium light-blue-bg text-center">
                              {{ totalFemme }}
                            </td>
                            <td class="px-1 py-2 inter-medium light-blue-bg text-center">
                              {{ totalFemme + totalHomme }}
                            </td>
                          </tr>
                          <tr>
                            <th class="px-1 py-2 inter-semibold light-blue-bg text-center">
                              Non admis
                            </th>
                            <td class="px-1 py-2 inter-medium light-blue-bg text-center">
                              {{ repecherTotalHomme }}
                            </td>
                            <td class="px-1 py-2 inter-medium light-blue-bg text-center">
                              {{ repecherTotalFemme }}
                            </td>
                            <td class="px-1 py-2 inter-medium light-blue-bg text-center">
                              {{ repecherTotalHomme + repecherTotalFemme }}
                            </td>
                          </tr>
                          <tr></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!--
        <div
          class="w-full p-1 flex-col justify-start items-start gap-2.5 inline-flex"
        >
          <div
            class="self-stretch bg-white h-full flex-col justify-start items-start gap-[60px] flex"
          >
            <div class="grid grid-rows-1">
              <div class="grid grid-cols-2 gap-8">
                <div class="mt-4">
                  <canvas id="canvasFamily" class="chart-canvas"></canvas>
                </div>
                <div class="mt-4 stat-p">
                  <canvas id="canvasGlobal" class="chart-canvas"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div> -->

                <!-- Title  -->

                <div class="self-stretch form-ctnr flex-col justify-start items-center gap-4 flex">
                  <form class="w-full grow shrink mb-8" action="" method="POST">
                    <div
                      class="pads-ctnr justify-center w-full self-stretch justify-start items-center gap-6 inline-flex">
                      <div class="pad pad-fields">
                        <div
                          class="pt-8 sm:pt-1 w-full flex justify-content-between flex-column gap-4 sm:flex-row align-items-center">
                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <div class="mb-2 font-semibold pr-db inter-semibold f14 text-gray-900 w-full">
                              Homme
                            </div>
                          </div>
                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <label
                              class="text-sm mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                              for="total_hom">Total</label>
                            <input [value]="totalHomme" id="total_hom" type="number"
                              class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                              readonly />
                          </div>
                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <label
                              class="text-sm mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                              for="devlog_hom">Dev log</label>
                            <input [value]="DEVhomme" id="devlog_hom" type="number"
                              class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                              readonly />
                          </div>
                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <label
                              class="text-sm mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                              for="tech_hom">Tech</label>
                            <input [value]="TECHhomme" id="tech_hom" type="number"
                              class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                              readonly />
                          </div>
                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <label
                              class="text-sm mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                              for="iad_hom">IA/D</label>
                            <input [value]="IAhomme" id="iad_hom" type="number"
                              class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                              readonly />
                          </div>
                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <label
                              class="text-sm mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                              for="ebus_hom">E-BUS</label>
                            <input [value]="EBUShomme" id="ebus_hom" type="number"
                              class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                              readonly />
                          </div>
                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <label
                              class="text-sm mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                              for="cca_hom">CCA</label>
                            <input [value]="CCAhomme" id="cca_hom" type="number"
                              class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                              readonly />
                          </div>
                        </div>
                        <div
                          class="pt-8 sm:pt-1 w-full flex justify-content-between flex-column gap-4 sm:flex-row align-items-center">
                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <div class="mb-2 font-semibold pr-db inter-semibold f14 text-gray-900 w-full">
                              Femme
                            </div>
                          </div>
                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <label
                              class="text-sm mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                              for="total_fem">Total</label>
                            <input [value]="totalFemme" id="total_fem" type="number"
                              class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                              readonly />
                          </div>
                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <label
                              class="text-sm mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                              for="devlog_fem">Dev log</label>
                            <input [value]="DEVfemme" id="devlog_fem" type="number"
                              class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                              readonly />
                          </div>
                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <label
                              class="text-sm mb-2 text-smmb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                              for="tech_fem">Tech</label>
                            <input [value]="TECHfemme" id="tech_fem" type="number"
                              class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                              readonly />
                          </div>
                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <label
                              class="text-sm mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                              for="iad_fem">IA/D</label>
                            <input [value]="IAfemme" id="iad_fem" type="number"
                              class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                              readonly />
                          </div>
                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <label
                              class="text-sm mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                              for="ebus_fem">E-BUS</label>
                            <input [value]="EBUSfemme" id="ebus_fem" type="number"
                              class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                              readonly />
                          </div>

                          <div class="field-ctnr pt-6 justify-start gap-5">
                            <label
                              class="text-sm mb-2 font-semibold pr-db font-medium inter-medium f14 text-gray-400 w-full"
                              for="cca_fem">CCA</label>
                            <input [value]="CCAfemme" id="cca_fem" type="number"
                              class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                              readonly />
                          </div>
                        </div>
                      </div>
                      <!-- ****************  Merci de ne pas supprimer ce code commente ***************************************  -->

                      <!-- <div class="pad pad-btns">
                <div class="w-full flex pt-8 justify-center items-center gap-5">
                  <button
                    (click)="toggleModal()"
                    type="button"
                    class="w-fit text-white mat-mdc-input-element dark-blue-bg inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                  >
                    Notifier par mail
                  </button>
                </div>
              </div> -->
                    </div>
                  </form>
                </div>
                <div class="self-stretch tab-recap-admis tableau-ctnr flex-col justify-start items-center gap-4 flex">
                  <!-- Old Table -->
                  <!--   <table  id="tableauAdmis" class="mat-elevation-z8 w-full text-sm tableau text-left rtl:text-right text-gray-500 dark:text-gray-400">
                        <thead class="text-sm inter-medium font-medium f12 bg-light-gray text-gray-700">
                            <tr>
                                <th scope="row" class="px-6 py-3">IUF</th>
                                <th scope="row" class="px-6 py-3">Prénom(s)</th>
                                <th scope="row" class="px-6 py-3">Nom</th>
                                <th scope="row" class="px-6 py-3">Age</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 ng-star-inserted" *ngFor="let admis of AllAdmis ">
                                <td scope="row" class="px-6 py-3 inter-medium font-medium text-gray-900 whitespace-nowrap dark:text-white" >{{admis.iuf}}</td>
                                <td scope="row" class="px-6 py-3 inter-regular f14">{{admis.firstName}}</td>
                                <td scope="row" class="px-6 py-3 inter-regular f14">{{admis.lastName}}</td>
                                <td scope="row" class="px-6 py-3 inter-regular f14">{{admis.age +" ans"}}</td>
                            </tr>
                        </tbody>
                    </table> -->
                  <div class="flex flex-wrap gap-4 w-full items-center">
                    <mat-form-field class="flex-1 min-w-[220px]">
                      <mat-label class="text-sm">Recherche</mat-label>
                      <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input />
                    </mat-form-field>

                    <div class="inline-flex items-center gap-5 ml-auto mb-5">
                      <button type="file"
                        class="text-white mat-mdc-input-element bg-green-500 font-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        (click)="exportAdmisExcel()">
                        Exporter en XLS
                      </button>
                      <button type="submit"
                        class="text-white mat-mdc-input-element bg-red font-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                        (click)="exportPDF()">
                        Exporter en PDF
                      </button>
                    </div>
                  </div>
                  <div
                    class="mat-elevation-z8 w-full text-sm tableau text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <table mat-table [dataSource]="dataSource" matSort>
                      <!-- ID Column -->
                      <ng-container matColumnDef="iuf">
                        <th *matHeaderCellDef mat-sort-header
                          class="px-6 py-3 text-sm f12 bg-greyLighter text-gray-700">
                          IUF
                        </th>
                        <td mat-cell *matCellDef="let row"
                          class="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          {{ row.iuf }}
                        </td>
                      </ng-container>

                      <!-- Progress Column -->
                      <ng-container matColumnDef="prenom">
                        <th *matHeaderCellDef mat-sort-header
                          class="px-6 py-3 text-sm f12 bg-greyLighter text-gray-700">
                          Prénom(s)
                        </th>
                        <td mat-cell *matCellDef="let row" class="px-6 py-3 f14">
                          {{ row.firstName }}
                        </td>
                      </ng-container>

                      <!-- Name Column -->
                      <ng-container matColumnDef="nom">
                        <th *matHeaderCellDef mat-sort-header class="px-6 py-3 text-sm bg-greyLighter text-gray-700">
                          Nom
                        </th>
                        <td mat-cell *matCellDef="let row" class="px-6 py-3 f14">
                          {{ row.lastName }}
                        </td>
                      </ng-container>

                      <!-- Fruit Column -->
                      <ng-container matColumnDef="age">
                        <th *matHeaderCellDef mat-sort-header
                          class="px-6 py-3 text-sm f12 bg-greyLighter text-gray-700">
                          Age
                        </th>
                        <td mat-cell *matCellDef="let row" class="px-6 py-3">
                          {{ row.age }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="mail">
                        <th *matHeaderCellDef mat-sort-header
                          class="px-6 py-3 text-sm f12 bg-greyLighter text-gray-700">
                          Mail Envoyé
                        </th>
                        <td mat-cell *matCellDef="let row" class="px-6 py-3">
                          <div class="sm etat pastille rounded-lg p-1 text-white w-fit text-center"
                            [style.backgroundColor]="
                              row.mailSent == true ? '#79D99C' : '#f04438'
                            " [style.color]="
                              row.mailSent == true ? '#027A48' : '#ffffff'
                            ">
                            {{ row.mailSent == true ? "Oui" : "Non" }}
                          </div>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="confirmation">
                        <th *matHeaderCellDef mat-sort-header
                          class="px-6 py-3 text-sm f12 bg-greyLighter text-gray-700">
                          Confirmation
                        </th>
                        <td mat-cell *matCellDef="let row" class="px-6 py-3">
                          <div class="sm etat pastille rounded-lg p-1 text-white w-fit text-center"
                            [style.backgroundColor]="
                              row.confirmation == true ? '#79D99C' : '#f04438'
                            " [style.color]="
                              row.confirmation == true ? '#027A48' : '#ffffff'
                            ">
                            {{ row.confirmation == true ? "Oui" : "Non" }}
                          </div>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="actions">
                        <th *matHeaderCellDef mat-sort-header class="px-6 py-3 text-sm bg-greyLighter text-gray-700">
                          Actions
                        </th>
                        <td mat-cell *matCellDef="let row" class="px-6 py-3 f14">
                          <button (click)="toggleModalDetails(row)"
                            class="focus:outline-none hover:bg-gray-100 focus:ring-2 focus:ring-gray-100">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                              stroke="currentColor" class="w-6 h-6 text-gray-800 dark:text-white">
                              <path stroke-linecap="round" stroke-linejoin="round"
                                d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                              <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                            </svg>
                          </button>
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                      <!-- Row shown when there is no matching data. -->
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell p-2" colspan="4">
                          No data matching the filter "{{ input.value }}".....
                        </td>
                      </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[50, 100, 150, 200]"
                      aria-label="Select page of users"></mat-paginator>
                  </div>
                  <div class="w-full inline-flex pt-8 justify-end items-end gap-5">
                    <button type="file"
                      class="text-white mat-mdc-input-element bg-green-500 font-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                      (click)="exportAdmisExcel()">
                      Exporter en XLS
                    </button>
                    <button type="submit"
                      class="text-white mat-mdc-input-element bg-red font-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                      (click)="exportPDF()">
                      Exporter en PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Alerte avant Envoi de Mails d'admission -->
        <div *ngIf="showModal" tabindex="-1" aria-hidden="true"
          class="bg-opacity-70 bg-gray-100 overflow overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
          <div class="relative w-auto my-6 mx-auto max-w-6xl">
            <div class="relative p-4 w-full max-w-2xl max-h-full">
              <!-- Modal content -->
              <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
                <!--  -->
                <!-- Modal body -->
                <div class="p-4 md:p-5 space-y-4 items-center justify-center">
                  <div class="flex justify-center items-center">
                    <div
                      class="mx-auto flex h-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0"
                      style="width: 11%">
                      <svg class="h-10 w-10 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1"
                        stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                      </svg>
                    </div>
                  </div>
                  <div class="flex justify-center items-center">
                    <p class="text-lg text-center leading-relaxed text-gray-500 dark:text-gray-400">
                      Vous allez envoyer les mails d'admission aux candidats
                      séléctionnés. <br />Merci de confirmer.
                    </p>
                  </div>
                  <div class="flex justify-center items-center">
                    <button (click)="notifierMail()" type="button"
                      class="w-full justify-center ml-3 rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto">
                      Confirmer
                    </button>
                    <button (click)="toggleModal()" type="button"
                      class="mt-3 w-full justify-center ml-3 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">
                      Annuler
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Notification mail d'Admission envoyé  -->

        <div *ngIf="showMailSent" tabindex="-1" aria-hidden="true"
          class="bg-opacity-70 bg-gray-100 overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
          <div class="relative w-auto my-6 mx-auto max-w-6xl">
            <div class="relative p-4 w-full max-w-2xl max-h-full">
              <!-- Modal content -->
              <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
                <!--  -->
                <!-- Modal body -->
                <div class="p-4 md:p-5 space-y-4 items-center justify-center">
                  <div class="flex justify-center items-center">
                    <p class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400">
                      Mails d'admission envoyés avec succès.
                    </p>
                  </div>
                  <div class="flex justify-center items-center">
                    <button (click)="closeMailSentDialog()" type="button"
                      class="w-full justify-center ml-3 rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto">
                      Fermer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="showDetails" tabindex="-1" aria-hidden="true"
          class="bg-opacity-70 bg-gray-100 overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 outline-none focus:outline-none justify-center items-center flex h-[calc(100%-1rem)] max-h-full">
          <div class="relative w-full my-6 mx-w-md max-w-6xl">
            <!-- Modal content -->
            <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
              <!-- Modal header -->
              <div class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                <h2 class="text-lg text-center font-semibold text-gray-900 dark:text-white">
                  Détails du candidat
                  {{ ligneDetails.firstName + " " + ligneDetails.lastName }}
                </h2>
                <button type="button" (click)="closeModalDetails()"
                  class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-toggle="crud-modal">
                  <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                  </svg>
                  <span class="sr-only">Fermer</span>
                </button>
              </div>
              <!-- Modal body -->
              <div class="p-4 md:p-5">
                <div class="grid gap-4 mb-4 grid-cols-2">
                  <div class="col-span-2 sm:col-span-1">
                    <h3 class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      Nom Prénom
                    </h3>
                    <p
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
                      {{ ligneDetails.lastName + " " + ligneDetails.firstName }}
                    </p>
                  </div>
                  <div class="col-span-2 sm:col-span-1">
                    <h3 class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      Email
                    </h3>
                    <p
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
                      {{ ligneDetails.email }}
                    </p>
                  </div>
                  <div class="col-span-2 sm:col-span-1">
                    <h3 class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      Numéro de Téléphone
                    </h3>
                    <p
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
                      {{ ligneDetails.phoneNumber }}
                    </p>
                  </div>
                  <div class="col-span-2 sm:col-span-1">
                    <h3 class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      Age
                    </h3>
                    <p
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
                      {{ ligneDetails.age }}
                    </p>
                  </div>
                  <div class="col-span-2 sm:col-span-1">
                    <h3 class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      Sexe
                    </h3>
                    <p
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
                      {{ ligneDetails.gender }}
                    </p>
                  </div>
                  <div class="col-span-2 sm:col-span-1">
                    <h3 class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      Note
                    </h3>
                    <p
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
                      {{ ligneDetails.mark }}
                    </p>
                  </div>
                  <div class="col-span-2 sm:col-span-1">
                    <h3 class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      Famille de métier
                    </h3>
                    <p
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
                      {{ ligneDetails.family }}
                    </p>
                  </div>
                  <div class="col-span-2 sm:col-span-1">
                    <h3 class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      Résidence
                    </h3>
                    <p
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
                      {{ ligneDetails.region }}
                    </p>
                  </div>
                  <div class="col-span-2 sm:col-span-1">
                    <h3 class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      Status
                    </h3>
                    <p
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
                      {{ ligneDetails.status }}
                    </p>
                  </div>
                </div>
                <button type="submit" (click)="closeModalDetails()"
                  class="text-white inline-flex items-center bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>